/**
 * What a plan is called once the app is running on it.
 *
 * "Starter" is the entry tier's name on the way IN — it is the one paid plan
 * the creation page offers, and that is the only screen where the word does any
 * work. The plan itself is shared CPU, exactly like the two above it, so
 * everywhere that describes an app which already has a plan calls it what it
 * is: Shared.
 *
 * Only the name comes back. The size belongs to the columns and the spec line
 * beside it, where it is labelled — printed into the name as well, it was the
 * copy with no heading over it.
 *
 * Its own module so that both halves of the Plan screen can read it without
 * importing each other.
 */
export const planDisplayName = (plan?: { name: string }): string =>
  plan?.name === 'Starter' ? 'Shared' : plan?.name || '';
